import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/api";
import { toast } from "@/components/ui/use-toast";
import { useTranslation } from "react-i18next";

const OwnerSetup = () => {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [emailInfo, setEmailInfo] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast({ title: t('ownerSetup.noToken'), variant: 'destructive' }); return; }
    if (!password || password !== confirm) { toast({ title: t('ownerSetup.mismatch'), variant: 'destructive' }); return; }
    try {
      setLoading(true);
      await api.ownerSetPassword({ token, password });
      toast({ title: t('ownerSetup.setSuccessTitle'), description: t('ownerSetup.setSuccessDesc') });
      navigate('/activate');
    } catch (e) {
      toast({ title: t('ownerSetup.errorTitle'), description: e.message, variant: 'destructive' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{t('ownerSetup.title')}</CardTitle>
          <CardDescription>{t('ownerSetup.desc')}</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-medium">{t('ownerSetup.password')}</label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
            <div>
              <label className="text-sm font-medium">{t('ownerSetup.confirm')}</label>
              <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>{loading ? t('ownerSetup.sending') : t('ownerSetup.save')}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default OwnerSetup;
